<div class="cipo cipo--width--full" fxLayout="column">
    <mat-dialog-content fxFlex="grow" class="m-x-lg m-b-lg">
        <div fxFlex="grow" class="p-x-xl cipo-bg--white cipo--overflow--auto">
            @if (isLoading()) {
                @for (_ of skeletonItems; track $index) {
                    <ngx-skeleton-loader
                        [theme]="{ width: '98%', height: '40px', margin: '8px' }"></ngx-skeleton-loader>
                }
            } @else {
                <mat-accordion cdkDropList multi displayMode="flat" (cdkDropListDropped)="drop($event)">
                    @for (relation of relations(); track relation.key) {
                        <mat-expansion-panel
                            #relationPanel
                            hideToggle
                            cdkDrag
                            disabled
                            [expanded]="(relation.children ?? []).length > 0"
                            [attr.node-id]="relation.key">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span class="cipo-text--bold-lg">{{ relation.value }}</span>
                                    <span class="m-l-sm">({{ relation.description }})</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            @if ((relation.children ?? []).length > 0) {
                                <mat-accordion
                                    cdkDropList
                                    displayMode="flat"
                                    (cdkDropListDropped)="dropChild(relation.key, $event)">
                                    @for (child of relation.children; track child.key) {
                                        <mat-expansion-panel
                                            #childPanel
                                            hideToggle
                                            cdkDrag
                                            disabled
                                            [attr.node-id]="child.key">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <span class="cipo-text--bold-lg">{{ child.value }}</span>
                                                    <span class="m-l-sm">({{ child.description }})</span>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                        </mat-expansion-panel>
                                    }
                                </mat-accordion>
                            }
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            }
        </div>
    </mat-dialog-content>
    <div fxLayoutAlign="end center" class="cipo--width--full p-a-sm" [class.cipo-bg--warning]="anythingChanged()">
        <button class="m-r-md" mat-button (click)="onCloseClick()" [disabled]="isLoading()">
            {{ "general.cancel" | translate }}
        </button>
        @if (anythingChanged()) {
            <button class="m-r-md" mat-button (click)="discardChanges()" [disabled]="isLoading()">
                {{ "general.discard" | translate }}
            </button>
            <button mat-raised-button color="primary" [disabled]="isLoading()" (click)="save()">
                {{ "general.save" | translate }}
            </button>
        }
    </div>
</div>
